.wrapper{position:absolute;top:0;right:0;bottom:0;left:0}.wrapper--active{pointer-events:auto}
/*# sourceMappingURL=canvas.component-6PU5V5PS.css.map */
